var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVistaOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.033,
    height: 18.711,
    viewBox: "0 0 14.033 18.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.033,4.093v12.863c0,.969-.786,1.754-1.754,1.754H1.754c-.968,0-1.754-.786-1.754-1.754V4.093c0-.969.786-1.754,1.754-1.754h3.238c-.015-.095-.022-.194-.022-.292,0-1.129.917-2.046,2.046-2.046s2.046.917,2.046,2.046c0,.099-.007.197-.022.292h3.238c.968,0,1.754.786,1.754,1.754Zm-1.169,0c0-.322-.263-.585-.584-.585h-1.754v.731c0,.241-.197.438-.438.438H3.947c-.241,0-.438-.197-.438-.438v-.731h-1.754c-.321,0-.584.263-.584.585v12.863c0,.322.263.585.584.585h10.525c.321,0,.584-.263.584-.585V4.093Zm-6.724-2.047c0,.486.391.877.877.877s.877-.391.877-.877-.391-.877-.877-.877-.877.391-.877.877Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVistaOrders);
export default __webpack_public_path__ + "static/media/icon-vista-orders.65b4f8e0.svg";
export { ForwardRef as ReactComponent };